/* This file is generated by a script. Do not modify. */

export const supportedComponents = [
  'Box',
  'Button',
  'ComparisonTable',
  'FAQ',
  'Heading',
  'Image',
  'Label',
  'SectionIntro',
  'Stack',
  'Testimonial',
  'Text',
  'Timeline',
  'Animate',
  'River',
  'RiverBreakout',
]
